import React, { useState } from "react";
import cx from "classnames";
import styles from "./AdditionalInfo.module.scss";
import Image from "@components/Image";

interface Props {
  data: {
    title: string;
    content: string | React.ReactNode;
  };
}

export default function Item({ data }: Props) {
  const [expand, setExpand] = useState(false);

  return (
    <div className={cx(styles.item)}>
      <div
        className={cx(
          styles.title,
          expand ? styles.expanded : styles.borderTopTitle
        )}
        onClick={() => setExpand(!expand)}
      >
        <div>{data.title}</div>
        <Image
          speed={0}
          animated={false}
          wrapperProps={{
            className: cx(styles.arrowIcon),
          }}
          src={"/about/sustainability/arrow-right.svg"}
          alt={`about-sustainability-arrow-right`}
          layout="fill"
          objectFit="contain"
        />
      </div>
      <div
        className={cx(styles.contentWrapper, {
          [styles.expandedContentWrapper]: expand,
        })}
      >
        <div className={cx(styles.content)}>{data.content}</div>
      </div>
    </div>
  );
}
